// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tsb-reportable-incidents.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tsb-reportable-incidents/tsb-reportable-incidents.js';

mount([g0]);
